import React from 'react';

import { updateGoalProgressLevelOnServerAction } from 'actions/task';
import GoalProgressSelect from 'screens/common/sidepanel/Goals/GoalProgressSelect';
import styled from 'styled-components';

import { GOAL_EVENTS1, sendGoalEvent } from 'constants/mixpanelHelper';
import { routesForTracking } from 'constants/routesForTracking';

export default function GoalStatus({ goalId, goalKey, dispatch, progressLevel, goalClosureStatus, pageName }) {
  return (
    <div onClick={(e) => e.stopPropagation()}>
      <StyledGoalProgressSelect
        progressLevel={progressLevel}
        goalClosureStatus={goalClosureStatus}
        onChange={(option) => {
          sendGoalEvent({
            page: { pageName, flow: 'Activity' },
            eventName: GOAL_EVENTS1.status,
            oldValue: {
              progressLevel,
              goalClosureStatus,
            },
            currentValue: {
              progressLevel: option.progressLevel,
              goalClosureStatus: option.value,
            },
            referrer: [routesForTracking.home.pageName, routesForTracking.profile.pageName].includes(pageName)
              ? 'MeshList'
              : 'Card',
          });

          dispatch(
            updateGoalProgressLevelOnServerAction({
              id: goalId,
              key: goalKey,
              progressLevel: option.progressLevel,
              goalClosureStatus: option.value,
            })
          );
        }}
      />
    </div>
  );
}

const StyledGoalProgressSelect = styled(GoalProgressSelect)`
  margin-left: -0.5rem;
  margin-bottom: -0.5rem;
`;
